import { UltimasMovimentacoes } from './../../../../models/processo.model';

import { ActivatedRoute, Router } from '@angular/router';
import { Component, Inject, OnInit } from '@angular/core';

import { ProcessoService } from '@app/services/processo.service';

import { Instancia, ProcessoResumo } from '@app/models/processo.model';

import { UsuarioTipoService } from '@app/services/usuario-tipo.service';

import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ToastrService } from 'ngx-toastr';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ParticipanteService } from '@app/services/participante.service';

@Component({
  selector: 'app-resumo',
  templateUrl: './resumo.component.html',
  styleUrls: ['./resumo.component.scss']
})
export class ResumoComponent implements OnInit {

  processoResumo: ProcessoResumo;
  urlServer: string;
  imgUrl: string = "assets/img/usuario-sem-img.png";
  acessoFinanceiro: boolean;
  acessoArquivo: boolean;
  acessoAnexos: boolean;
  acessoAudiencia: boolean;
  acessoDocumentos: boolean;
  acessoEntrevista: boolean;
  acessoObservacao: boolean;
  acessoPeticaoOnline: boolean;
  acessoGerarDocs: boolean;
  acessoDadosProcesso: boolean;
  acessoDadosCliente: boolean;
  acessoAtendimento: boolean;
  acessoUltimasMovsAdm: boolean;
  acessoUltimasMovsJud: boolean;
  acessoUltimasMovsEP: boolean;
  ultimasCincoMovimentacoes: UltimasMovimentacoes;
  mostrarUltimasMovimentacoes: boolean = false;
  listaGrupoInstancia: Map<string, Instancia[]> = new Map();

  processoId: any;
  dataAssinaturaContrato: string; 
  bsModalRef: BsModalRef;
  ativaCampoAssinatura: boolean = true;
  possuiPermissaoAlterarDataAssinatura: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private participanteService: ParticipanteService,
    private usuarioTipoService: UsuarioTipoService,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
  }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        if (this.processoId.includes("-e")) {
          this.processoId = parseInt(this.processoId.split('-e')[0]);
        }
        this.obterResumo(this.processoId);
      });
      this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
        (permissoes: any) =>{
          this.acessoFinanceiro = permissoes.find(x => x.Descricao == 'Financeiro').Selecionado;
          this.acessoAnexos = permissoes.find(x => x.Descricao == 'Anexos').Selecionado;
          this.acessoArquivo = permissoes.find(x => x.Descricao == 'Arquivo').Selecionado;
          this.acessoAudiencia = permissoes.find(x => x.Descricao == 'Audiencias').Selecionado;
          this.acessoDocumentos = permissoes.find(x => x.Descricao == 'Documentos').Selecionado;
          this.acessoEntrevista = permissoes.find(x => x.Descricao == 'Entrevistas').Selecionado;
          this.acessoObservacao = permissoes.find(x => x.Descricao == 'Observacao').Selecionado;
          this.acessoPeticaoOnline = permissoes.find(x => x.Descricao == 'PeticaoOnline').Selecionado;
          this.acessoGerarDocs = permissoes.find(x => x.Descricao == 'GerarDocs').Selecionado;

          this.acessoDadosProcesso = permissoes.find(x => x.Descricao == 'EditarDadosProcesso').Selecionado;
          this.acessoDadosCliente = permissoes.find(x => x.Descricao == 'EditarDadosCliente').Selecionado;
          this.acessoAtendimento = permissoes.find(x => x.Descricao == 'GerarAtendimento').Selecionado;

          this.acessoUltimasMovsAdm = permissoes.find(x => x.Descricao == 'MovimentacoesAdministrativas').Selecionado;
          this.acessoUltimasMovsJud = permissoes.find(x => x.Descricao == 'MovimentacoesJudiciais').Selecionado;
          this.acessoUltimasMovsEP = permissoes.find(x => x.Descricao == 'MovimentacoesExecucaoProvisoria').Selecionado;
        });
  }

  resumoMovimentacao(processoId: number){
    const elementosDireita = document.querySelectorAll('.fa-chevron-right');
    if (elementosDireita.length > 0){
      this.processoService.obterResumoUltimasMovimentacoes(processoId).subscribe(data => {
        this.ultimasCincoMovimentacoes = data;
        elementosDireita.forEach((element: HTMLElement)=> {
          element.classList.replace('fa-chevron-right', 'fa-chevron-down');
        });
        this.mostrarUltimasMovimentacoes = true;
      });
    }
    else{
      const elementosParaBaixo = document.querySelectorAll('.fa-chevron-down');
      elementosParaBaixo.forEach((element: HTMLElement)=> {
        element.classList.replace('fa-chevron-down', 'fa-chevron-right');
      });
      this.mostrarUltimasMovimentacoes = false;
    }
  }

  obterResumo(processoId: number) {
    this.processoService.obterResumo(processoId).subscribe(data => {
      this.processoResumo = data;
      this.listaGrupoInstancia = new Map();
      this.processoResumo.InstanciasProcesso.forEach(instancia => {
        if(!this.listaGrupoInstancia.has(instancia.DescricaoInstancia)){
          this.listaGrupoInstancia.set(instancia.DescricaoInstancia, [instancia]);
        } else {
          let temp = this.listaGrupoInstancia.get(instancia.DescricaoInstancia)
          this.listaGrupoInstancia.set(instancia.DescricaoInstancia, [...temp,instancia]);
        }
      })

      if (this.processoResumo.Foto) {
        this.imgUrl = this.processoResumo.Foto;
      }
      else {
        this.imgUrl = "assets/img/usuario-sem-img.png"
      }
      
      this.ativarCampoAssinatura();
    });
    
  }

  gravarDataAssinatura(){
    this.processoService.assinarContrato(this.processoId, this.dataAssinaturaContrato).subscribe(
      () => {
        this.toastr.success("Data de assinatura adicionada com sucesso!");
        this.obterResumo(this.processoId);
      },
      (data: any) => {
        if (data.error) {
          this.toastr.error(data.error.errors);
        }
      }
    );
  }

  excluirDataAssinaturaContrato(){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja mesmo excluir a data de assinatura do contrato?';
    this.bsModalRef.content.confirmar = () => {
      this.processoService.excluirAssinaturaContrato(this.processoId).subscribe(
        () => {
          this.ativaCampoAssinatura = !this.ativaCampoAssinatura;
          this.toastr.success("Data de assinatura excluída com sucesso!");
          this.obterResumo(this.processoId);
        },
        (data: any) => {
          this.toastr.error(data.error.errors);
        }
      )
    }
  }

  ativarCampoAssinatura(){
    if(this.processoResumo.DataAssinaturaContrato === '0001-01-01T00:00:00') { 
      this.ativaCampoAssinatura = true;
    }
    else { 
      this.ativaCampoAssinatura = false;
    }

    this.participanteService.verificaPermissaoUsuario(0, 'AlterarDataAssinaturaContrato')
      .subscribe(data => {
        this.possuiPermissaoAlterarDataAssinatura = data;
    });
  }
}
